// This array contains the standard membership prices for Fabletics members.
// These prices are used to validate and ensure consistency with the membership table.
const membershipPrices = ['59.95', '69.95'];
export default membershipPrices;
